<template>
  <div class="w-100">
    <b-col cols="12">
      <b-form-group label="ویدیو های کلاس" label-for="videoFile">
        <b-form-file
          ref="videoInput"
          id="videoFile"
          multiple
          @input="emitVideos"
          accept=".mp4, .mov, .mpeg, .mkv"
        ></b-form-file>
      </b-form-group>
      <b-row
        v-if="videoFilesConcated && videoFilesConcated.length > 0"
        class="my-2"
      >
        <b-col
          cols="1"
          v-for="(item, index) in videoFilesConcated"
          :key="`video${index}`"
          class="position-relative"
        >
          <img
            @click="handleVideoModal(handleMediaView(item))"
            v-b-modal.modal-video
            style="width: 100px; height: 100px; cursor: pointer"
            src="@/assets/images/static/video-static.png"
          />
          <feather-icon
            icon="Trash2Icon"
            size="20"
            class="text-danger position-absolute"
            style="top: 0.4rem; cursor: pointer"
            @click="deleteVideo(item)"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-form-group label="عکس های کلاس" label-for="picFile">
        <b-form-file
          ref="imageInput"
          id="picFile"
          @input="emitImages"
          multiple
          accept=".jpg, .jpeg, .png"
        ></b-form-file>
      </b-form-group>
      <b-row
        v-if="imageFilesConcated && imageFilesConcated.length > 0"
        class="my-2"
        style="grid-gap: 1rem 0"
      >
        <b-col
          cols="1"
          v-for="(item, index) in imageFilesConcated"
          :key="`image${index}`"
          class="position-relative"
          style="width: 100%"
        >
          <img
            @click="handleImageModal(handleMediaView(item))"
            v-b-modal.modal-image
            src="@/assets/images/static/picture-placeholder.png"
            style="width: 100px; height: 100px; cursor: pointer"
          />
          <feather-icon
            icon="Trash2Icon"
            size="25"
            class="text-danger position-absolute"
            style="top: 0.4rem; cursor: pointer"
            @click="deletePicture(item)"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-form-group label="پادکست های کلاس" label-for="audioFile">
        <b-form-file
          ref="audioInput"
          id="audioFile"
          @input="emitAudios"
          multiple
          accept=".mp3, .wav"
        ></b-form-file>
      </b-form-group>
      <b-row
        v-if="audioFilesConcated && audioFilesConcated.length > 0"
        class="my-2"
        style="grid-gap: 1rem 0"
      >
        <b-col
          cols="1"
          v-for="(item, index) in audioFilesConcated"
          :key="`audio${index}`"
          class="position-relative"
          style="width: 100%"
        >
          <img
            @click="handleAudioModal(handleMediaView(item))"
            v-b-modal.modal-audio
            src="@/assets/images/static/audio-placeholder.png"
            style="width: 100px; height: 100px; cursor: pointer"
          />
          <feather-icon
            icon="Trash2Icon"
            size="25"
            class="text-danger position-absolute"
            style="top: 0.4rem; cursor: pointer"
            @click="deleteAudio(item)"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-form-group label="مقاله های کلاس" label-for="textFile">
        <b-form-file
          ref="textInput"
          id="textFile"
          @input="emitTexts"
          multiple
          accept=".docs, .pdf, .txt, .docx"
        ></b-form-file>
      </b-form-group>
      <b-row
        v-if="textFilesConcated && textFilesConcated.length > 0"
        class="my-2"
        style="grid-gap: 1rem 0"
      >
        <b-col
          cols="1"
          v-for="(item, index) in textFilesConcated"
          :key="`text${index}`"
          class="position-relative"
          style="width: 100%"
        >
          <img
            @click="handleTextMedia(item)"
            src="@/assets/images/static/doc-placeholder.jpg"
            style="width: 100px; height: 100px; cursor: pointer"
          />
          <feather-icon
            icon="Trash2Icon"
            size="25"
            class="text-danger position-absolute"
            style="top: 0.4rem; cursor: pointer"
            @click="deleteText(item)"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-modal
      title="مشاهده ویدیو"
      id="modal-video"
      centered
      ok-title="بستن"
      @ok="removeTempVideo"
      ok-only
    >
      <div class="position-relative p-1 border rounded-lg shadow-sm">
        <video
          preload="metadata"
          class="rounded-lg"
          controls
          :src="tempVideo"
          style="width: 100%; max-height: 17rem"
        ></video>
        <div class="w-100 mt-1">
          <div
            class="actions d-flex align-items-center justify-content-between mt-1"
          >
            <div
              v-if="tempVideoObject && tempVideoObject.mediaId"
              class="actions d-flex align-items-center justify-content-between"
            >
              <!-- @click="createArvanVideo(item)" -->
              <b-button
                @click="renderVideoTitleModal(tempVideoObject)"
                variant="info"
                size="sm"
                v-if="!tempVideoObject.arvanCloudVideoId"
              >
                محافظت از ویدیو
              </b-button>
              <!-- :variant="
                        tempVideoObject.arvanCloudVideoId && !tempVideoObject.arvanCloudPlayerUrl
                          ? 'info'
                          : 'success'
                      " -->
              <b-badge
                v-if="tempVideoObject.arvanCloudVideoId"
                size="sm"
                pill
                class="font-weight-normal"
                variant="transparent"
                :class="
                  tempVideoObject.arvanCloudVideoId &&
                  !tempVideoObject.arvanCloudPlayerUrl
                    ? 'border-info text-info'
                    : 'border-success text-success'
                "
              >
                {{
                  tempVideoObject.arvanCloudVideoId &&
                  !tempVideoObject.arvanCloudPlayerUrl
                    ? "در حال تبدیل"
                    : "محافظت شده"
                }}
              </b-badge>
            </div>
            <b-badge
              v-if="tempVideoObject && !tempVideoObject.mediaId"
              pill
              size="sm"
              class="font-weight-normal text-warning border-warning"
              variant="transparent"
            >
              ذخیره نشده
            </b-badge>
            <feather-icon
              icon="Trash2Icon"
              size="20"
              class="text-danger cursor-pointer"
              @click="deleteVideo(tempVideoObject)"
            />
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      title="مشاهده تصویر"
      id="modal-image"
      centered
      ok-title="بستن"
      @ok="removeTempImage"
      ok-only
    >
      <img
        :src="tempImage"
        style="width: 100%; height: 100%; max-height: 70vh; object-fit: contain"
      />
    </b-modal>
    <b-modal
      title="شنیدن پادکست"
      id="modal-audio"
      centered
      ok-title="بستن"
      @ok="removeTempAudio"
      ok-only
    >
      <div class="d-flex align-items-center justify-content-center">
        <audio controls :src="tempAudio"></audio>
      </div>
    </b-modal>
    <b-modal
      title="عنوان ویدیو"
      id="modal-video-title"
      centered
      ok-title="ثبت"
      cancel-title="بستن"
      @ok="createArvanVideo"
      :ok-disabled="!tempVideoDetails.title"
    >
      <b-container fluid>
        <b-form-row>
          <b-col cols="12">
            <b-form-group label="عنوان ویدیو" label-for="video-title">
              <b-form-input
                v-model="tempVideoDetails.title"
                size="sm"
                id="video-title"
                placeholder="آیلتس 1"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import { CreateArvanVideo } from "@/libs/Api/ArvanCloud";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BContainer,
  BFormRow,
  BCard,
  BRow,
  BBadge,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BButton,
} from "bootstrap-vue";
export default {
  emits: [
    "deleteVideo",
    "getVideoArray",
    "deletePicture",
    "getImageArray",
    "getAudioArray",
    "deleteAudio",
    "getTextArray",
    "deleteText",
    "refetch",
  ],
  props: {
    textFilesConcated: {
      type: Array,
    },
    audioFilesConcated: {
      type: Array,
    },
    imageFilesConcated: {
      type: Array,
    },
    videoFilesConcated: {
      type: Array,
    },
  },
  data() {
    return {
      tempVideo: null,
      tempImage: null,
      tempAudio: null,
      tempDoc: null,
      tempVideoObject: null,
      tempVideoDetails: {
        title: null,
        description: null,
        mediaId: null,
      },
    };
  },
  methods: {
    renderVideoTitleModal(media) {
      this.tempVideoDetails.mediaId = media.mediaId;
      this.$bvModal.show("modal-video-title");
    },
    closeRenderVideoModal() {
      this.$bvModal.hide("modal-video-title");
    },
    async createArvanVideo() {
      try {
        this.isLoading = true;
        let _this = this;
        let createArvanVideo = new CreateArvanVideo(_this);
        createArvanVideo.setRequestParam(_this.tempVideoDetails);
        await createArvanVideo.fetch((response) => {
          if (
            response.message &&
            response.message == "video created successfully."
          ) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویدیو در صف تبدیل قرار گرفت.",
                icon: "EditIcon",
                variant: "success",
              },
            });

            _this.$emit("refetch");
            this.closeRenderVideoModal();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش در سرور پیش آمده، لطفا دوباره امتحان کنید.",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.tempVideoObject = {
          title: null,
          description: null,
          mediaId: null,
        };
        this.isLoading = false;
      }
    },
    removeTempAudio() {
      this.tempAudio = null;
    },
    handleAudioModal(audio) {
      this.tempAudio = audio;
    },
    removeTempImage() {
      this.tempImage = null;
    },
    handleImageModal(image) {
      this.tempImage = image;
    },
    removeTempVideo() {
      this.tempVideo = null;
    },
    handleVideoModal(video) {
      this.tempVideo = video;
    },
    deleteText(text) {
      this.$emit("deleteText", text);
    },
    handleTextMedia(item) {
      window.open(this.handleMediaView(item));
    },
    emitTexts(files) {
      if (files && files.length > 0) {
        this.$emit("getTextArray", files);
      }
    },
    deleteAudio(audio) {
      this.$emit("deleteAudio", audio);
    },
    emitAudios(files) {
      if (files && files.length > 0) {
        this.$emit("getAudioArray", files);
      }
    },
    emitVideos(files) {
      if (files && files.length > 0) {
        this.$emit("getVideoArray", files);
      }
    },
    deleteVideo(video) {
      this.$emit("deleteVideo", video);
    },
    deletePicture(image) {
      this.$emit("deletePicture", image);
    },
    emitImages(files) {
      if (files && files.length > 0) {
        this.$emit("getImageArray", files);
      }
    },
    handleMediaView(file) {
      // Deciding whether file is blob or url
      if (file && file.mediaId) {
        this.tempVideoObject = file;
        return `${this.baseUrl}/${file.pictureUrl}`;
      } else if (file.File) {
        return URL.createObjectURL(file.File);
      }
    },
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BContainer,
    BCard,
    BFormRow,
    BRow,
    BBadge,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BButton,
  },
};
</script>
